import { useEffect, useMemo } from 'react';
import { MuiThemeProvider } from './MUI';
import { Main } from './components/Main/Main';
import getLang from './utils/getLang';
import { refetchTokens } from './utils/refetchTokens';
import { useChat } from './context/Context';
import { createUserTheme } from './MUI/createUserTheme';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const currentLang = getLang();

export const App = () => {
    const {
        socketInstance,
        widgetId,
        token,
        isWidgetBlocked,
        initializeSocket,
        widgetData,
        fetchStaticWidgetData,
        setShowWidget,
        refreshBite,
    } = useChat();

    useEffect(() => {
        const intervalId = setInterval(() => {
            const expires = localStorage.getItem('expires');
            const storedWidgetId = localStorage.getItem('widgetId');

            if (!expires || !storedWidgetId) return;

            const expiresAt = new Date(expires);
            const now = new Date();
            const diffMinutes = (expiresAt - now) / 1000 / 60;

            if (diffMinutes <= 6) {
                refetchTokens().then(() => {
                    const refreshedToken = localStorage.getItem('refresh');
                    if (!refreshedToken) return;

                    fetch(`${BASE_URL}/widget/${storedWidgetId}/refresh`, {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${refreshedToken}`,
                        },
                    }).then(() => initializeSocket());
                });
            }
        }, 300000);

        return () => clearInterval(intervalId);
    }, [initializeSocket]);

    useEffect(() => {
        if (widgetId && token && !isWidgetBlocked) {

            fetchStaticWidgetData({
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setShowWidget(true);
        }
    }, [token, widgetId, isWidgetBlocked]);

    useEffect(() => {
        if (!socketInstance) return;
        socketInstance.on('site.widget.settings', fetchStaticWidgetData);

        return () => {
            socketInstance.off('site.widget.settings', fetchStaticWidgetData);
        };
    }, [socketInstance, fetchStaticWidgetData]);

    useEffect(() => {
        if (widgetData) {
            localStorage.setItem('user_settings', JSON.stringify(widgetData));
        }
    }, [widgetData]);

    const getUserTheme = useMemo(() => {
        return createUserTheme(widgetData, refreshBite);
    }, [widgetData, refreshBite]);

    if (!widgetData || isWidgetBlocked) return null;

    return (
        <MuiThemeProvider getUserTheme={getUserTheme}>
            <Main />
        </MuiThemeProvider>
    );
};
